<template>
  <transition name="slide-fade" >

    <div  id="academicsHolder" >
      <div class="uk-child-width-1-1" uk-grid>


        <div class="uk-background-muted uk-margin-remove-top">
          <div class="uk-container uk-container-small">

          </div>
          <div class="uk-container uk-container-small">
            <div class="uk-alert-primary uk-padding-small uk-margin-top uk-border-rounded"  uk-alert>

              <p class="uk-text-center">Click the degree you are interested in for more information.
                <br>
                <span class="uk-text-center">
<!--                  <a href="#deps" class="uk-link-text uk-text-small uk-text-muted" uk-scroll="offset: 300px; duration: 2000">See department abbreviations</a>-->
                </span>
              </p>
            </div>

            <div >
              <router-link v-for="item in gradPrograms"  :to="'/grad/' + item.slug " class="" style="text-decoration: none;">
                <div class="uk-card uk-card-default" style="border-radius: 15px; margin-bottom: 15px">
                  <div class="uk-card-media-top">
                    <!--<img :src="'http://cmsapi.ncu.edu.jm/' + item.thumbnailImage" class="uk-responsive-height uk-responsive-width" alt=""
                         style="max-width: 300px; max-height: 300px; height: auto; width: auto; border-top-left-radius: 15px; border-top-right-radius: 15px; ">-->
                  </div>
                  <div class="uk-card-body uk-padding-small" >
                    <!-- <h4 class="specHeading" style="color: rgb(197,179,88) !important;">{{ item.degreeName }}</h4>-->
                    <div>
                      <div class="">
                        <div :id="item.id" @click="findDegree(item.acf.program_slug)" style="cursor: pointer" class="uk-flex uk-flex-between ">
                          <div>
                            <div>
                              <h3 class="  uk-text-bold" style=" font-weight: bold">{{ item.acf.program_name }}</h3>
                            </div>
                            <div style="margin-top: -15px">
                              <span class="uk-badge uk-text-small" style="padding: 5px 10px; background-color: rgb(165, 214, 167); color: #333" v-for="(i, index) in item.acf.campuses_offered">

                                {{ index < (item.acf.campuses_offered.length -1) ? i + ", " : i }}
                              </span>
                            </div>
                          </div>
                          <div style="padding-top: 5px">
                            <div>{{ item.acf.program_level }}</div>
                            <span uk-icon="icon:chevron-right; ratio: 1.5" ></span>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </router-link>

            </div>

<!--               <div>
                 <div class="uk-child-width-1-1 uk-grid-small uk-grid-match uk-container uk-container-small uk-visible@l" uk-grid>
                   &lt;!&ndash;   Search Bar         &ndash;&gt;
                   <div class="uk-margin">
                     <form class="uk-search uk-search-large">
                       <span uk-search-icon></span>
                       <input class="uk-search-input" type="search" placeholder="Search degree..." v-model="search">
                     </form>
                   </div>


                 </div>
               </div>

            <div class=" uk-hidden@l ">
              <form class="uk-search uk-search-default">
                <span uk-search-icon></span>
                <input class="uk-search-input " type="search" placeholder="Search..." v-model="search" style="width: 100%">

              </form>
            </div>



            <div class="uk-overflow-auto">
              <table class="uk-table  uk-table-divider ">
                <thead>
                <tr>
                  <th style="color: rgb(197,179,88) !important;font-size: medium" class="uk-heading-bullet specHeading">List of Graduate Degrees</th>



                  <th class="uk-table-shrink">Dept.</th>
                  <th class="uk-table-shrink">MPH</th>
                  <th class="uk-table-shrink">MBA</th>
                  <th class="uk-table-shrink">MA</th>
                  <th class="uk-table-shrink">MSC</th>
                  <th class="uk-table-shrink">PhD</th>
                </tr>
                </thead>
                <tbody class="">
                <tr v-for="item in filterName">
                  <td>
                    <a href="javascript:" :id="item.slug" v-on:click="findDegree" :uk-tooltip="'Learn more about a degree in ' + item.degree_name" class="uk-button-link  uk-uk-text-bold ">{{ item.degree_name }} </a>
                  </td>
                  <td>
                    <span  class="uk-margin-small-right uk-text-primary uk-text-center">{{ item.department }}</span>
                  </td>
                  <td>
                    <span v-if="item.masters_of_ph" class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td>
                    <span v-if="item.masters_of_business" class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>

                  <td>
                    <span v-if="item.masters_arts" class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>

                  <td>
                    <span v-if="item.masters_of_science" class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                  <td class="uk-text-center">
                    <span v-if="item.doctorial" class="uk-margin-small-right uk-text-primary" uk-icon="check"></span>
                  </td>
                </tr>

                </tbody>
              </table>
            </div>
            <div v-if="imgHide">
              <img src="../assets/loading.gif" style="max-height: 220px; max-width: 220px; width: auto; height: auto;" alt="" class="uk-align-center">
            </div>
            <h3 id="deps" class="uk-heading-bullet specHeading uk-margin-remove-bottom">Departments</h3>
            <div class="uk-child-width-1-2@m uk-padding uk-padding-remove-vertical" uk-grid>
              <div class=" uk-padding-small uk-margin-top uk-border-rounded uk-text-small uk-text-muted" >
                <p class="">BHM - Department of Business and Hospitality Management </p>
                <p class="">GEL - Department of Graduate Education and Leadership </p>
                <p class="">GP - Department of Graduate Psychology </p>


              </div>
              <div class=" uk-padding-small uk-margin-top uk-border-rounded uk-text-small uk-text-muted" >

                <p class="">CIS - Department of Computer and Information Science</p>
                <p class="">BCES - Department of Biology, Chemistry and Environmental Sciences </p>

              </div>
            </div>
            <br><br>-->
          </div>
        </div>
      </div>

    </div>
  </transition>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "gradprograms",
      components:{

      },

      data(){
        return {
          image: location.origin + '/static/logo.png',
          imgHide: true,
          search:"",
          show:true
        }
      },
      methods: {
        findDegree: function(event){
          //this.$store.commit('getArticle', (event.target.id))
          //console.log(event.target)
          this.$router.push({ path: '/grad', query: { degreeName: event.target.id }})
        },

      },
      computed: {
        loadDegrees: function () {
          //this.pageLoad = true
          //console.log(this.$store.state.undergradDegrees.associate_degree)


          return this.$store.state.degree.gradDegrees
        },
        filterName(){
          return this.loadDegrees.filter((item)=>{
            return item.degree_name.match(this.search) ;
          })
        },
        gradPrograms: function(){
          return this.$store.state.gradDegrees
          /*console.log(this.$store.state.degree)
          console.log(this.$store.getters['degrees'])
          return this.$store.state.degree.programmeResults.filter((x) => {
            if (x.LevelName === "Graduate") {
              //alert(x.ProgramsPlus)
              console.log(x)
              return x.ProgramsPlus
            }
          })*/
        },

      },
      mounted(){
        window.scrollTo(0, 0);
        this.$store.dispatch('getGraduateDegrees')
        //this.$store.dispatch('degree/GetAllPrograms')
      },
      beforeCreate(){
        //this.$store.dispatch('degree/AllGradDegrees')
      },
      updated(){
        this.imgHide = false
      },
      metaInfo: {
        // Children can override the title.
        title: 'NCU Graduate Degree Programs',
        // Result: My Page Title ← My Site
        // If a child changes the title to "My Other Page Title",
        // it will become: My Other Page Title ← My Site
        //titleTemplate: '%s ← My Site',
        // Define meta tags here.
        meta: [
          { 'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8' },
          { name: 'viewport', content: 'width=device-width, initial-scale=1' },
          { name: 'description', content: 'Graduate Degrees offered by Northern Caribbean University' }
        ]
      }
    }
</script>

<style scoped>
  #academicsHolder{
    min-height: 75vh;
  }
  .colorIt{
    color: #333 !important;
  }
  .borderIt{
    border: #333 solid 1px !important;
  }
  .bgIt{
    background-color: #333 !important;
  }
  .whiteIt{
    color: white !important;
  }
  .smallSize{
    font-size: 10pt !important;
  }
  h4, h5{
    color: silver !important;
  }
  tr > td{
    border: 1px solid #EEEEEE;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 15px;
    padding-right: 15px;
  }
  input{
    /*width: 400px;*/
    border: 0px solid white;
  }
  button{
    width: 50px;
  }
  #degreeCard:hover{
    background-color: rgba(225, 245, 254, 0.4);
  }

  @media screen and (max-width:600px){



    p,li{
      font-size: 0.8em !important;
    }
    th{
      font-size:small !important;
    }


  }
</style>
